


export const LOAD_ROSTER_OWNER = "LOAD_ROSTER_OWNER";
export const LOAD_ROSTER_SUCCESS_OWNER = "LOAD_ROSTER_SUCCESS_OWNER";
export const LOAD_ROSTER_ERROR_OWNER = "LOAD_ROSTER_ERROR_OWNER";